APP = {
    common: {

        nav: function() {
            /* Open when someone clicks on the span element */
            openNav = function () {
                $('nav').addClass('is-active');
            };

            /* Close when someone clicks on the "x" symbol inside the overlay */
            closeNav = function() {
                $('nav').removeClass('is-active');
            };

            $('body').on('click', '.nav-open', function (event) {
                if( $('nav').hasClass('is-active') ){
                    closeNav();
                } else {
                    openNav();
                }
            });
            $('nav').find('.nav-link:not(.forceredir)').on('click',function(e) {
                e.preventDefault();
                window.history.pushState(null, "", $(this).attr('href'));
                closeNav();
                  // Figure out element to scroll to
                  var target = $(this).attr('data-target');
                  target = $(target);
                  // Does a scroll target exist?
                  if (target.length) {
                    // Only prevent default if animation is actually gonna happen
                    var diff = target.offset().top - $(window).scrollTop();
                    if (diff >= 1000 || diff <= -1000) {
                        if (diff<=0) { var pos = target.offset().top + 1000; }
                        else {
                            var pos = target.offset().top - 1000;
                        }
                        $('html, body').animate({scrollTop: pos},0);
                    }

                    $('html, body').animate({
                      scrollTop: target.offset().top
                    }, 1000, function() {
                      // Callback after animation
                      // Must change focus!
                      var $target = $(target);
                      $target.focus();
                      if ($target.is(":focus")) { // Checking if the target was focused
                        return false;
                      } else {
                        $target.attr('tabindex','-1'); // Adding tabindex for elements not focusable
                        $target.focus(); // Set focus again
                      };
                    });
              }
            });
        },
        gallery: function() {
        },

        loadDisc: function() {
            $discs = $("#discos").find('ul');
            $discs.find('a').on('click',function (e) {
                e.preventDefault();
                var href = $(this).attr('href');
                $.ajax({
                    url: href,
                    success: function(result) {
                        // $item = $parent.append(result.html);
                        // $('#discModal').find('.modal-content').html("");
                        $('#discModal').find('.modal-content').html(result);
                        console.log(result);
                        window.history.pushState(null, "", href);


                    }
                });
            });
            $('#discModal').on('hidden.bs.modal', function () {
                $('#discModal').find('.modal-body').html("");
            });
        },
        loadBook: function() {
            $discs = $("#livros").find('article');
            $discs.find('a').on('click',function (e) {
                e.preventDefault();
                var href = $(this).attr('href');
                $.ajax({
                    url: href,
                    success: function(result) {
                        // $item = $parent.append(result.html);
                        $('#bookModal').find('.modal-body').html("");
                        $('#bookModal').find('.modal-body').html(result);
                        window.history.pushState(null, "", href);


                    }
                });
            });
            $('#bookModal').on('hidden.bs.modal', function () {
                $('#bookModal').find('.modal-body').html("");
            });
        },

        loadPost: function() {
            $("#noticias").on('click','a.loadPost',function (e) {
                e.preventDefault();
                var href = $(this).attr('href');
                $.ajax({
                    url: href,
                    success: function(result) {
                        // $item = $parent.append(result.html);
                        $('#postModal').find('.modal-body').html("");
                        $('#postModal').find('.modal-body').html(result);
                        window.history.pushState(null, "", href);

                    }
                });
            });
            $('#postModal').on('hidden.bs.modal', function () {
                $('#postModal').find('.modal-body').html("");
            });
        },
        loadMore: function() {
            $("#noticias").find('.load-more').on('click',function (e) {
                e.preventDefault();

                $last = $("#noticias").find('article').last().attr('data-rel');
                var href = "./noticias/loadmore/"+ $last;
                $.ajax({
                    url: href,
                    success: function(result) {
                        if (result.success == true) {
                            $item = $('#noticias').find('article').last().after(result.html);
                        } else {
                            $item = $('#noticias').find('.load-more').remove();
                        }

                    }
                });
            });
        },
        contactForm: function() {
            $("#contact-form").validate({
                rules: {
                    name: "required",
                    email: {
                        required: true,
                        email: true
                    },
                    content: "required"
                },
                messages: {
                    name: "Oi! Qual o seu nome?",
                    email: {
                        required: "Nós precisamos do seu endereço de e-mail.",
                        email: "Este e-mail não parace um e-mail."
                    },
                    content: "Qual a mensagem?"
                },

                submitHandler: function(form) {
                    var data = $(form).serialize(),
                        url  = $(form).attr('action'),
                        place_return = $(form).find('.return');

                    $.ajax({
                        type: "POST",
                        url: url,
                        data: data,
                        dataType: 'json',
                        beforeSend: function() {
                            $(place_return).removeClass('success fail').addClass('sending active').html('Enviando sua mensagem...');

                        },
                        success: function(response) {
                            $(place_return).removeClass('sending');
                            if (response.status) {
                                $(place_return).addClass('success').html(response.message);
                            }
                            else {
                                $(place_return).addClass('fail').html('O envio não foi realizado. Tente novamente mais tarde.');
                            }
                            setTimeout(function(){ $(place_return).removeClass().addClass('return').empty(); }, 10000);
                        },
                        error: function (response) {
                            $(place_return).removeClass('sending');
                            $(place_return).addClass('fail').html('O envio não foi realizado. Tente novamente mais tarde.');
                            setTimeout(function(){ $(place_return).removeClass().addClass('return').empty(); }, 10000);
                        }
                    });
                }
            });

        },
        detectModal: function () {
            var modal = $('body').attr('data-modal');
            var modaurl = $('body').attr('data-modalurl');
            if (modal) {
                $.ajax({
                    url: modaurl,
                    success: function(result) {
                        $item = $(modal).find('.modal-body').html(result);
                        $(modal).modal('show');
                    }
                });
                window.history.pushState(null, "", modaurl);
            }
        },
        bindGeneralEvents: function () {
            $('body').scrollspy({target: "#navbar-scroll"}).on('activate.bs.scrollspy', function () {
            });
            var images = jQuery.parseJSON($('header').attr('data-images'));
            $("body>header").vegas({
                slides: images,
                transitionDuration: 2000,
                overlay: false,
                transition: 'fade',
                delay: 10000,

            });
            $(window).scroll(function() {
                if($(window).scrollTop() < $(window).innerHeight()) {
                    $('nav.is-active').removeClass('is-active');
                }
            });
        },


        init: function () {

            APP.common.bindGeneralEvents();
            // APP.common.accordion();
            APP.common.nav();

            APP.common.loadDisc();
            APP.common.loadBook();
            APP.common.loadMore();
            APP.common.loadPost();
            APP.common.contactForm();
            APP.common.detectModal();

        },
        accordionControl: {
            close: function (el) {
                if ($(el).children('c-accordion__content:visible')) {
                    $(el).trigger('click');
                }
            },
            open: function (el) {
                if ($(el).children('c-accordion__content:hidden')) {
                    setTimeout(function () {
                        $(el).trigger('click');
                    }, 1000);
                }
            }
        }

    },

    archives: {

        index: function () {

            // APP.common.fixedAlertBar();

        }

    }
};

UTIL = {
    exec: function (controller, action) {
        var namespace = APP;
        action = (action === undefined) ? "init" : action;

        if (controller !== "" && namespace[controller] && typeof namespace[controller][action] == "function") {
            namespace[controller][action]();
        }
    },

    init: function () {
        var body = document.body;
        var controller = body.getAttribute("data-controller");
        var action = body.getAttribute("data-action");

        UTIL.exec("common");
        UTIL.exec(controller);
        UTIL.exec(controller, action);
    }
};
$(document).ready(UTIL.init);
